angular.module('internal.applications')
    .directive('internalApplicationHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'applications/components/application-header/application-header.html',
            controller: 'InternalApplicationHeader',
            replace: true
        };
    }])
    .controller('InternalApplicationHeader', ['$rootScope', '$scope', 'Permissions', function ($rootScope, $scope, Permissions) {
        $scope.internalURL = $rootScope.internalURL;
        $scope.getPermission = function (state, variable, method) {
            Permissions[method](state).then(function (access) {
                $scope[variable] = access;
            })
        }
    }])
;